import { JSX } from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import ComplianceConnectDashboard from "@app/compliance-connect/regulator/ComplianceConnectDashboard";
import NetworkComparisonPage from "@app/compliance-connect/regulator/NetworkComparisonPage";

const ComplianceConnectRegulatorRouter = (props: RouteComponentProps): JSX.Element => (
    <Switch>
        <Route path={`${props.match.path}/network-comparison`} component={NetworkComparisonPage} />
        <Route component={ComplianceConnectDashboard} />
    </Switch>
);

export default ComplianceConnectRegulatorRouter;
